import React from "react";
import {useNavigate} from "react-router";
import {loadTemplates} from "../../assets/Template";
import "./MapTemplateSelector.css";
import {debug_log} from "../../utils/debug";
import {JourneyMap} from "../../API";

type TemplateData = {
    title: string;
    label: string;
    description: string;
    preview: string;
    data: string;
}

type TemplateByCategory = {
    category: string;
    templates: TemplateData[];
}

function makeTemplateByCategoryList(): TemplateByCategory[] {
    const templates = loadTemplates();
    const map = new Map<string, TemplateData[]>();

    for (const template of templates) {

        const list = map.get(template.category);
        if (list === undefined) {
            map.set(template.category, [template]);
        } else {
            list.push(template);
        }
    }

    const ret: TemplateByCategory[] = [];
    map.forEach((templates, category) => ret.push({category, templates}));
    return ret;
}

type MapTemplateSelectorProps = {
    createMap: (title: string, json_string: string) => Promise<JourneyMap>;
}

export const MapTemplateSelector = (props: MapTemplateSelectorProps) => {
    const navigate = useNavigate();

    const createAndMove = (title: string, json_string: string) => {
        props.createMap(title, json_string)
            .then((new_map: JourneyMap) => {
                navigate("/m/" + new_map.id);
            }).catch((e) => {
                debug_log(e.message);
            }
        );
    }

    const template_by_category_list = makeTemplateByCategoryList();

    return (
        <div className="template-area" onClick={e => e.stopPropagation()}>
            {template_by_category_list.map(template_by_category =>
                <div key={template_by_category.category}>
                    <h3 className="template-category-name">{template_by_category.category}</h3>
                    <div className="template-list">
                        {template_by_category.templates.map(template =>
                            <div className="template-wrap" key={template.label}>
                                <div className="template">
                                    <img src={template.preview} alt="preview" className="preview"
                                         onClick={() => createAndMove(template.title, template.data)}/>
                                    <h4 className="label">{template.label}</h4>
                                    <p className="description">{template.description}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
